import React from 'react'
import PropTypes from 'prop-types'

const LockSVG = ({ size, fill }) => (
  <svg
    width={size}
    height={size}
    viewBox={'0 0 24 24'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 8.5h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-3-11v2h6v-2c0-1.66-1.34-3-3-3s-3 1.34-3 3z"
      fill={fill}
    />
  </svg>
)

LockSVG.defaultProps = {
  size: '24',
  fill: '#D5DDE4',
}

LockSVG.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string.isRequired,
}

export default LockSVG
